module.exports = __webpack_public_path__ + "static/media/facebook-rounded-icon.ab81f549.png";